module.exports = __webpack_public_path__ + "img/adver_banner2.1e05ee6a.png";